import { IApplicationState } from '../../types/redux';

export function getBreadcrumbs(state: IApplicationState) {
  return state.developerV2?.seo?.breadcrumbs || [];
}
